module.exports = __webpack_public_path__ + "static/media/Subaru_logo_white.c86b6a61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Subaru_logo_white.svg
// module id = 309
// module chunks = 0